import { SagaIterator } from 'redux-saga';
import { call } from 'typed-redux-saga';

export function* createTransitionUid(): SagaIterator<string> {
  const n = yield* call(Math.random);
  return n.toString(36).substring(2);
}
